module.exports = __webpack_public_path__ + "static/80percent-05f073ac60eb126fcb1b970f4be3a7d0.png";